/* eslint sort-keys: "error"*/
var DEFAULT_SCORM_SETTINGS = {
  allowNewAttemptWhenReopeningNewCourse: true,
  autoLaunchFirstSco: true,
  closePopupMultiScoBehavior: '',
  closePopupSingleScoBehavior: 'exit',
  commentsFromLMS: '',
  exitAction: 'close',
  failedStatusCountsAsDone: false,
  getCredit: 'credit',
  masteryScoreMode: 'after_completion',
  navigationType: '',
  openContentIn: 'inline',
  popupWindowParams: '',
  reenterActivity: true,
  returnToLastScoOnLaunch: false,
  saveDataOnCommit: true,
  saveDataOnSetValue: false,
  scoreAllowChangeAfterCompleted: true,
  scoreAllowChangeAfterFailed: true,
  scoreAllowChangeAfterPassed: true,
  scoreAllowReduce: true,
  scoreRollupAction: '',
  scoreRollupIncludeScosWithNoScore: false,
  startIncomplete: 'not_attempted',
  statusAllowChangeAfterCompleted: true,
  statusAllowChangeAfterFailed: true,
  statusAllowChangeAfterPassed: true,
  statusAllowCompletionOnUnsetFinish: true,
  statusRollupAction: ''
};
export default DEFAULT_SCORM_SETTINGS;